import React from "react"
import PropTypes from "prop-types"
import GTM from "@src/services/gtm"
import ToursLayoutLazy from "@src/layouts/tours-lazy"
import { ImagePropTypes } from "@src/components/core-image"
import { PageSeoPropTypes } from "@src/components/page-helmet"
import { TourDetailTilePropTypes } from "@src/components/content-tour-detail-tile"
import { orderByField } from "@src/utils/sorting"

const PageTemplate = ({ pageContext: { data, ...pageContext } }) => {
  const {
    wpPage: { seo: pageSeo },
    allWpPost: { nodes: posts },
    tenTours: {
      tours: { nodes: tourData },
      tourRegions: { nodes: tourRegions },
    },
  } = data
  const {
    basePath,
    pageNumber,
    pageCount,
    postsPerPage: toursPerPage,
    postsTotal: totalTours,
    postIds: toursOrder,
    tourRegions: tourRegionsOrder,
  } = pageContext
  GTM.dataLayerPushPageInfo({
    template: "tours-all",
  })
  const textTop =
    "From hiking through dramatic mountain landscapes to cycling along serene coastlines, 10Adventures tours offer something unique for every traveller. Explore our catalogue of carefully curated itineraries in over 85 countries to find the perfect blend of discovery, connection, and awe-inspiring moments that make active travel such a special experience. Choose one of the tours below and take the first step on your next adventure."
  return (
    <ToursLayoutLazy
      pageSeo={{ ...pageSeo, metaRobotsNoindex: "index" }}
      headerText={textTop}
      tourData={tourData?.sort(orderByField("id", toursOrder))}
      toursParentUri={basePath}
      toursPageNumber={pageNumber}
      toursPageCount={pageCount}
      toursPerPage={toursPerPage}
      totalTours={totalTours}
      featuredTourRegions={tourRegions?.sort(
        orderByField("slug", tourRegionsOrder),
      )}
      posts={posts}
    />
  )
}

PageTemplate.propTypes = {
  pageContext: PropTypes.shape({
    basePath: PropTypes.string,
    pageNumber: PropTypes.number,
    pageCount: PropTypes.number,
    postsPerPage: PropTypes.number,
    postsTotal: PropTypes.number,
    postIds: PropTypes.arrayOf(PropTypes.number),
    tourRegions: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.shape({
      wpPage: PropTypes.shape({
        seo: PropTypes.shape({ ...PageSeoPropTypes }),
        images: PropTypes.shape({
          header: PropTypes.shape({ ...ImagePropTypes }),
        }),
      }),
      allWpPost: PropTypes.shape({
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            uri: PropTypes.string,
            images: PropTypes.shape({
              featureTile: PropTypes.shape({ ...ImagePropTypes }),
            }),
          }),
        ),
      }),
      tenTours: PropTypes.shape({
        tours: PropTypes.shape({
          nodes: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number,
              ...TourDetailTilePropTypes,
            }),
          ),
        }),
        tourRegions: PropTypes.shape({
          nodes: PropTypes.arrayOf(
            PropTypes.shape({
              title: PropTypes.string,
              uri: PropTypes.string,
              images: PropTypes.shape({
                featureTile: PropTypes.shape({ ...ImagePropTypes }),
              }),
            }),
          ),
        }),
      }),
    }),
  }),
}

export default PageTemplate
